import NextImage from 'next/image'
import Link from 'next/link'

const Logo = ({ variant = 'default', position = 'header' }) => {
  let logoSrc = '/logo.png'

  if (variant === '60') {
    logoSrc = position === 'footer' ? '/logo-60-footer.png' : '/logo-60.png'
  }

  function getLogoInitialSize() {
    // https://nextjs.org/docs/pages/api-reference/components/image#width
    // […] used to infer the correct aspect ratio of the image
    // […] does not determine the rendered size of the image
    // […] the rendered size in the browser, […] will be determined by the parent container
    // The logos can have different aspect ratios, so here's their sizes
    if (variant === '60') {
      if (position === 'footer') {
        return {
          width: 1031,
          height: 1001,
        }
      }

      if (position === 'header') {
        return {
          width: 1182,
          height: 1182,
        }
      }
    } else {
      return {
        // The generic default variant,
        // intrinsic size of logo.png
        width: 295,
        height: 432,
      }
    }
  }

  return (
    <div
      className='airc-logo'
      data-variant={variant}
      data-position={position}
    >
      <Link href='/'>
        <NextImage
          src={logoSrc}
          alt='Logo'
          sizes='100vw'
          className='airc-logo__image'
          {...getLogoInitialSize()}
        />
      </Link>
    </div>
  )
}

export default Logo
